import React from 'react';
import PropTypes from 'prop-types';

export default class TouchComponent extends React.Component {
    constructor(props) {
        super(props);

        this._onTouchStart = this._onTouchStart.bind(this);
        this._onTouchMove = this._onTouchMove.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);

        this.state = {swiped: false};
        this._swipe = {};
        this._touchStarted = false;
        this.minDistance = 50;
    }

    _onTouchStart(e) {
        const touch = e.touches[0];

        this._swipe = {y: touch.screenY};
        this._touchStarted = true;

        this.setState({swiped: false});
    }

    _onTouchMove(e) {
        if (e.changedTouches && e.changedTouches.length) {
            this._swipe.swiping = true;
        }
    }

    _onTouchEnd(e) {
        const touch = e.changedTouches[0];
        const absY = Math.abs(touch.screenY - this._swipe.y);

        if (this._touchStarted) {
            // Touch started on this element and it just ended here
            if (this._swipe.swiping && absY > this.minDistance) {
                // ...and we had movement, so it was a swipe event.
                this.props.onSwiped && this.props.onSwiped();
                this.setState({swiped: true});
            } else {
                // ...and we had no movement, so it was a tap (touch click).
                this.props.onTap && this.props.onTap();
            }
        }

        this._touchStarted = false;
        this._swipe = {};
    }

    render() {
        return (
            <div
                {...this.props} onTouchStart={this._onTouchStart} onTouchMove={this._onTouchMove}
                onTouchEnd={this._onTouchEnd}>
                {this.props.children}
            </div>
        );
    }
}

TouchComponent.propTypes = {
    onTap: PropTypes.func,
    onSwiped: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/Etc/TouchComponent.js